/**
 * Pobiera słownik polskich tłumaczeń (server-side)
 * Zawsze zwraca polskie tłumaczenia z /locales/pl/
 */
export async function getDictionary(name: string) {
  try {
    const dict = await import(`@/locales/pl/${name}.json`)
    return dict
  } catch (error) {
    console.error(`Translation file not found: pl/${name}.json`)
    throw error
  }
}
